<template>
  <AppStart v-if="state === 'loading'" />

  <div v-else-if="state === 'error'">
    <AppError />
    <pre
      v-if="errorMessage"
      style="white-space: pre-wrap; margin-top: 12px;"
    >{{ errorMessage }}</pre>
  </div>

  <App v-else />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import App from "./app/App.vue";
import AppStart from "./app/AppStart.vue";
import AppError from "./app/AppError.vue";

import { useAccountStore } from "@/stores/accountStore";
import apiAuth from "@/shared/services/apiAuth";

import Keycloak, { type KeycloakConfig } from "keycloak-js";

type BootstrapState = "loading" | "error" | "ready";

const state = ref<BootstrapState>("loading");
const errorMessage = ref<string>("");

onMounted(async () => {
  try {
    const resp = await apiAuth.init();

    if (!resp.successful) {
      state.value = "error";
      errorMessage.value = String(resp.message ?? "Unbekannter Fehler bei apiAuth.init()");
      return;
    }

    const accountStore = useAccountStore();
    accountStore.setInstallation(resp);

    const keycloakConfig = resp.keycloak;

    if (keycloakConfig.active && resp.shopId !== "eVB_Aktivierung") {
      const initOptions: KeycloakConfig = {
        url: keycloakConfig.keycloakUrl || "",
        realm: keycloakConfig.realm || "",
        clientId: keycloakConfig.clientId || "",
      };

      const keycloak = new Keycloak(initOptions);
      apiAuth.setKeycloak(keycloak);

      const auth = await keycloak.init({
        onLoad: "check-sso",
        silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
        checkLoginIframe: false,
      });

      accountStore.authenticated = keycloak.authenticated === true;

      if (auth) {
        await apiAuth.authenticatePrivate();
      }
    }

    state.value = "ready";
  } catch (e) {
    console.error(e);
    state.value = "error";
    errorMessage.value = e instanceof Error ? e.message : String(e);
  }
});
</script>
